/** Super admin panel sayfa SSOT — doktor/tenant panel ile hizalı */

import { PANEL } from "./panelTokens";
import {
  panelTableCardSx,
  panelListSectionTitleSx,
  panelListTableContainerSx,
  panelListTableSx,
  panelMetaChipSx,
} from "./panelCardSx";
import { panelFormFieldSx } from "./panelFormSx";
import { panelContentSx } from "./panelLayoutSx";

export const superAdminPageSx = {
  ...panelContentSx,
  display: "flex",
  flexDirection: "column",
  gap: 2.5,
  width: "100%",
  boxSizing: "border-box",
};

export const superAdminPageHeaderSx = {
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "space-between",
  gap: 2,
  flexWrap: "wrap",
};

export const superAdminPageHeaderMainSx = {
  display: "flex",
  alignItems: "center",
  gap: 1.5,
  minWidth: 0,
};

export const superAdminPageHeaderIconSx = {
  width: 44,
  height: 44,
  borderRadius: "12px",
  display: "grid",
  placeItems: "center",
  flexShrink: 0,
  bgcolor: PANEL.accent.soft12,
  color: PANEL.accent.text,
  border: `1px solid ${PANEL.accent.softBorder22}`,
  "& .MuiSvgIcon-root": { fontSize: 24 },
};

export const superAdminPageTitleSx = {
  ...panelListSectionTitleSx,
  mb: 0,
  fontSize: "1.75rem",
};

export const superAdminPageActionsSx = {
  display: "flex",
  alignItems: "center",
  gap: 1,
  flexWrap: "wrap",
  ml: { xs: 0, md: "auto" },
};

export const superAdminFilterPanelSx = {
  ...panelTableCardSx,
  p: 2,
};

export const superAdminFilterGridSx = {
  display: "grid",
  gridTemplateColumns: {
    xs: "1fr",
    sm: "repeat(2, minmax(0, 1fr))",
    md: "repeat(4, minmax(0, 1fr))",
  },
  gap: 1.5,
  mb: 1.5,
};

export const superAdminFilterFieldSx = panelFormFieldSx;

export const superAdminPaginationBarSx = {
  ...panelTableCardSx,
  p: 1.5,
};

export const superAdminPaginationMetaSx = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  flexWrap: "wrap",
  gap: 1.5,
};

export const superAdminDetailLabelSx = {
  fontSize: "0.8125rem",
  color: PANEL.text.muted,
  mb: 0.35,
  fontWeight: 600,
};

export const superAdminDetailValueSx = {
  fontSize: "0.9375rem",
  color: PANEL.text.primary,
  lineHeight: 1.45,
};

export const superAdminDetailCardSx = {
  p: 1.25,
  borderRadius: PANEL.radius.cardSm,
  bgcolor: PANEL.fill.muted,
  border: `1px solid ${PANEL.border}`,
  mb: 1,
};

export const superAdminChartCardSx = {
  ...panelTableCardSx,
  p: { xs: 2, md: 2.5 },
  height: "100%",
};

export const superAdminChartTitleSx = {
  fontWeight: 700,
  fontSize: "1rem",
  color: PANEL.text.primary,
  mb: 2,
};

export const superAdminTableWrapSx = panelListTableContainerSx;

export const superAdminTableSx = panelListTableSx;

export const superAdminMetaChipSx = panelMetaChipSx;

export const superAdminLoadingSx = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  py: 8,
};

export const superAdminJsonBlockSx = {
  position: "relative",
  borderRadius: PANEL.radius.cardSm,
  border: `1px solid ${PANEL.border}`,
  bgcolor: PANEL.fill.muted,
  overflow: "hidden",
};

export const superAdminJsonPreSx = {
  m: 0,
  p: 2,
  overflow: "auto",
  fontSize: "0.8rem",
  lineHeight: 1.5,
  fontFamily: "'Fira Code', 'Consolas', monospace",
  color: PANEL.text.primary,
  whiteSpace: "pre-wrap",
  wordBreak: "break-word",
};
